<div class="login-main">
    <div class="login-shared-main-body">
        <div class="login-form-container">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-main-body-form-container">
                <div class="login-shared-intro-text">Enter code</div>
                <app-alert-error *ngIf="countdownTimedOut">Your request has expired. Please refresh the page and try again.</app-alert-error>
                <ng-container *ngIf="!countdownTimedOut">
                    <app-login-mfa-code formControlName="mfaCode"
                                        [isInvalidCode]="isInvalidCode"
                                        [isExpiredRequest]="isExpiredRequest"
                                        [isLockedOut]="isLockedOut"
                                        (countdownTimedOut)="onCountdownTimedOut()"></app-login-mfa-code>
                    <div class="login-submit-ctr">
                        <button type="submit" [disabled]="!form.valid" class="login-btn-submit">Next</button>
                    </div>
                </ng-container>
            </form>
        </div>
    </div>
</div>